import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["postalCode", "prefecture", "city", "street"]

  connect() {
    if (!this.hasPostalCodeTarget) {
      return
    }

    this.postalCodeTarget.addEventListener("blur", this.lookupAddress.bind(this))
  }

  async lookupAddress() {
    const postalCode = this.postalCodeTarget.value.replace(/-/g, "")

    if (postalCode.length !== 7) {
      return
    }

    try {
      const response = await fetch(`/api/addresses/${postalCode}`)
      const data = await response.json()

      if (data.prefecture) {
        this.prefectureTarget.value = data.prefecture
        this.cityTarget.value = data.city
        this.streetTarget.value = data.street

        // selectフィールドの場合、changeイベントを発火させる
        if (this.prefectureTarget.tagName === 'SELECT') {
          this.prefectureTarget.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }
    } catch (error) {
      // エラーが発生しても何もしない（ユーザーが手動入力できるため）
    }
  }
}
